import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { taxis } from '../../data/taxis';
import './CarDetail.css';

const CarDetail = () => {
  const { slug } = useParams();
  const [car, setCar] = useState(null);

  // Contact form state
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // Find the car by slug
    const foundCar = taxis.find(t => t.slug === slug);
    setCar(foundCar);
  }, [slug]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const response = await fetch('https://hook.eu2.make.com/2t459gwcwzl5ywtmjunkpke62g4hspg1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          timestamp: new Date().toISOString(),
          source: 'car-detail-page',
          carModel: car.model,
          carSlug: car.slug,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit form');
      }

      // Reset form after successful submission
      setFormData({
        name: '',
        phone: '',
        email: '',
      });
      
      // Show success message
      setSuccessMessage('תודה! הודעתך נשלחה בהצלחה.');
    } catch (err) {
      console.error('Error submitting form:', err);
      setErrorMessage('אירעה שגיאה בשליחת ההודעה. אנא נסה שוב מאוחר יותר.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!car) {
    return <div>Car not found</div>;
  }

  return (
    <div className="car-detail-page">
      <div className="container">
        <h1 className="car-title">{car.model}</h1>
        <div className="car-image-container">
          <img src={car.image} alt={car.model} className="car-image" />
        </div>
        <p className="car-price">₪{car.price.toLocaleString()} כולל מע"מ</p>
        <p className="car-explanation">{car.explanation}</p>

        {/* Contact Form Section */}
        <section className="car-detail-contact-form">
          <h2>צרו איתנו קשר בנוגע ל{car.model}</h2>
          {successMessage && <div className="success-message">{successMessage}</div>}
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          <form onSubmit={handleSubmit} className="horizontal-contact-form">
             <div className="form-group">
              <label htmlFor="name">שם מלא</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required disabled={isSubmitting} />
            </div>
            <div className="form-group">
              <label htmlFor="phone">טלפון</label>
              <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required disabled={isSubmitting} />
            </div>
            <div className="form-group">
              <label htmlFor="email">דוא"ל</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required disabled={isSubmitting} />
            </div>
            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? 'שולח...' : 'שלח הודעה' }
            </button>
          </form>
        </section>
      </div>
    </div>
  );
};

export default CarDetail; 